// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.manage-user {
  padding-bottom: 30px;
}

.radio,
.checkbox {
  display: inline-block;
  margin-bottom: 20px;
}
.radio .product-name,
.checkbox .product-name {
  font: 1.6rem "Omnes-ATT-W02-Medium";
  color: #333333;
}

.user-information {
  padding-left: 34px;
}

.display-column {
  margin-bottom: 10px;
}

button.btn {
  margin-right: 0;
}

.tiny-accordion {
  width: 100%;
}

.panel {
  display: block;
  padding: 0 15px;
}

.unassign-panel .panel:last-child {
  margin-bottom: 27px;
}

.showpanel {
  display: none !important;
}

.toggle-header {
  border-color: white;
  border-top: 1px solid #d2d2d2;
  color: hsl(204.9, 94.4%, 35.1%);
  cursor: pointer;
  display: block;
  font-size: 2rem;
  line-height: 2.2rem;
  padding: 16px 15px 20px 0;
  position: relative;
}
.toggle-header .icon-accordion-plus,
.toggle-header .icon-accordion-minus {
  display: inline-block;
  font-size: 20px;
  margin-top: -12px;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 50%;
  vertical-align: middle;
}
.toggle-header a {
  display: block;
  margin-left: 15px;
}
.toggle-header.toggle-header-open a {
  color: #333333;
}

.user-details li {
  background-image: linear-gradient(to right, black 33%, rgba(255, 255, 255, 0) 0%);
  background-position: 3px 15px;
  background-repeat: repeat-x;
  background-size: 3px 1px;
  display: table;
  font-family: "Omnes-ATT-W02-Medium";
  line-height: 15px;
  padding: 7px 0;
  width: 100%;
}
.user-details li .user-name {
  background-color: white;
  display: table-cell;
  float: left;
  padding-left: 0;
  padding-right: 7px;
  text-align: left;
  max-width: 40%;
  word-break: break-word;
}
.user-details li .user-email {
  background-color: white;
  display: table-cell;
  float: right;
  padding-left: 7px;
  padding-right: 0;
  text-align: left;
  word-break: break-all;
  width: 50%;
}
.user-details.single-user {
  margin-bottom: 30px;
}

.btn-inline {
  margin-left: -15px !important;
}

.review-btn {
  margin-bottom: 20px;
}

.review-page-title {
  margin-bottom: 20px;
}

hr.top-bottom {
  margin: 10px 0 30px;
}

.review-unassign {
  border-top: 1px solid #d2d2d2;
  padding-top: 30px;
}

.first-cell {
  width: 100px;
}

@media (max-width: 1024px) {
  .manage-user {
    padding-bottom: 0;
  }
  .panel {
    padding: 0;
  }
  .toggle-header {
    margin: 0 -15px;
  }
  h2 {
    margin-bottom: 20px;
  }
  .btn-sm-block {
    margin-bottom: 20px;
    margin-left: 0 !important;
    margin-right: 0;
    width: 100%;
  }
  a.btn-sm-block {
    margin-bottom: 0;
  }
  .form-group {
    margin-bottom: 20px;
  }
  .btn-inline {
    margin-left: 0 !important;
    margin-top: 20px;
    width: 100%;
  }
  hr.top-bottom {
    margin: 0 0 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-users/manage-users.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,oBAAA;AAkJF;;AA/IA;;EAEE,qBAAA;EACA,mBAAA;AAkJF;AAhJE;;EACE,mCAAA;EACA,cAAA;AAmJJ;;AA/IA;EACE,kBAAA;AAkJF;;AAhJC;EACE,mBAAA;AAmJH;;AAhJE;EACE,eAAA;AAmJJ;;AA/IA;EACE,WAAA;AAkJF;;AA/IA;EACE,cAAA;EACA,eAAA;AAkJF;;AA9II;EACE,mBAAA;AAiJN;;AA7IA;EACE,wBAAA;AAgJF;;AA7IA;EACE,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAgJF;AA9IE;;EAEE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AAgJJ;AA7IE;EACE,cAAA;EACA,iBAAA;AA+IJ;AA1II;EACE,cAAA;AA4IN;;AAtIE;EACE,iFAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;EACA,cAAA;EACA,mCAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAyIJ;AAvII;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAyIN;AAtII;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;AAwIN;AApIE;EACE,mBAAA;AAsIJ;;AAlIA;EACE,6BAAA;AAqIF;;AAlIA;EACE,mBAAA;AAqIF;;AAlIA;EACE,mBAAA;AAqIF;;AAjIE;EACE,mBAAA;AAoIJ;;AAhIA;EACE,6BAAA;EACA,iBAAA;AAmIF;;AA/HA;EACE,YAAA;AAkIF;;AFhQI;EEkIF;IACE,iBAAA;EAkIF;EA/HA;IACE,UAAA;EAiIF;EA9HA;IACE,eAAA;EAgIF;EA7HA;IACE,mBAAA;EA+HF;EA3HA;IACE,mBAAA;IACA,yBAAA;IACA,eAAA;IACA,WAAA;EA6HF;EAzHE;IACE,gBAAA;EA2HJ;EAvHA;IACE,mBAAA;EAyHF;EAtHA;IACE,yBAAA;IACA,gBAAA;IACA,WAAA;EAwHF;EApHE;IACE,gBAAA;EAsHJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n// Action\n.manage-user  {\n  padding-bottom: 30px;\n}\n\n.radio,\n.checkbox {\n  display: inline-block;\n  margin-bottom: 20px;\n\n  .product-name {\n    font: 1.6rem 'Omnes-ATT-W02-Medium';\n    color: color(inverse, dark);\n  }\n}\n\n.user-information {\n  padding-left: 34px;\n}\n .display-column {\n   margin-bottom: 10px;\n }\nbutton {\n  &.btn {\n    margin-right: 0;\n  }\n}\n\n.tiny-accordion {\n  width: 100%;\n}\n\n.panel {\n  display: block;\n  padding: 0 15px;\n}\n.unassign-panel {\n  .panel{\n    &:last-child{\n      margin-bottom: 27px;\n    }\n  }\n}\n.showpanel {\n  display: none !important;\n}\n\n.toggle-header {\n  border-color: color(default, light);\n  border-top: 1px solid color(default, dark);\n  color: color(secondary, base);\n  cursor: pointer;\n  display: block;\n  font-size: 2rem;\n  line-height: 2.2rem;\n  padding: 16px 15px 20px 0;\n  position: relative;\n\n  .icon-accordion-plus,\n  .icon-accordion-minus {\n    display: inline-block;\n    font-size: 20px;\n    margin-top: -12px;\n    padding: 0;\n    position: absolute;\n    right: 15px;\n    top: 50%;\n    vertical-align: middle;\n  }\n\n  a {\n    display: block;\n    margin-left: 15px;\n  }\n\n  &.toggle-header-open {\n\n    a {\n      color: color(inverse, dark);\n    }\n  }\n}\n\n.user-details {\n  li {\n    background-image: linear-gradient(to right, black 33%, rgba(255,255,255,0) 0%);\n    background-position: 3px 15px;\n    background-repeat: repeat-x;\n    background-size: 3px 1px;\n    display: table;\n    font-family: 'Omnes-ATT-W02-Medium';\n    line-height: 15px;\n    padding: 7px 0;\n    width: 100%;\n\n    .user-name {\n      background-color: color(default, light);\n      display: table-cell;\n      float: left;\n      padding-left: 0;\n      padding-right: 7px;\n      text-align: left;\n      max-width: 40%;\n      word-break: break-word;\n    }\n\n    .user-email {\n      background-color: color(default, light);\n      display: table-cell;\n      float: right;\n      padding-left: 7px;\n      padding-right: 0;\n      text-align: left;\n      word-break: break-all;\n      width: 50%;\n    }\n  }\n  \n  &.single-user {\n    margin-bottom: 30px;\n  }\n}\n\n.btn-inline {\n  margin-left: -15px !important;\n}\n\n.review-btn {\n  margin-bottom: 20px;\n}\n\n.review-page-title {\n  margin-bottom: 20px;\n}\n\nhr {\n  &.top-bottom {\n    margin: 10px 0 30px;\n  }\n}\n\n.review-unassign {\n  border-top: 1px solid color(default, dark);\n  padding-top: 30px;\n}\n\n\n.first-cell {\n  width: 100px;\n}\n\n@include respond-to(small) {\n  .manage-user  {\n    padding-bottom: 0;\n  }\n\n  .panel {\n    padding: 0;\n  }\n\n  .toggle-header {\n    margin: 0 -15px;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n  }\n\n\n  .btn-sm-block {\n    margin-bottom: 20px;\n    margin-left: 0 !important;\n    margin-right: 0;\n    width: 100%;\n  }\n\n  a {\n    &.btn-sm-block {\n      margin-bottom: 0;\n    }\n  }\n\n  .form-group {\n    margin-bottom: 20px;\n  }\n\n  .btn-inline {\n    margin-left: 0 !important;\n    margin-top: 20px;\n    width: 100%;\n  }\n\n  hr {\n    &.top-bottom {\n      margin: 0 0 20px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
